import {autoplayInterval, handleTabActivation} from "../components/tab-slider/tab-slider.js";
import {addClassToElements, removeClassFromElements} from "../components/helper.js";

export function initTabSlider(Collapse) {
  const tabSliderElement = document.querySelector('.tab-slider'),
    tabElements = tabSliderElement ? tabSliderElement.querySelectorAll('.tab') : false;

  if (!tabElements) return;
  let interval = null;

  new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (!entry.target.classList.contains('progressing')) {
          addClassToElements('progressing', [entry.target])
          interval = autoplayInterval(tabSliderElement, Collapse);
        }
      } else {
        removeClassFromElements('progressing', [entry.target])
        clearInterval(interval);
      }

      removeClassFromElements('clicked', [entry.target])
    })
  }).observe(tabSliderElement);

  tabElements.forEach(tabElement => {
    tabElement.addEventListener('click', () => {
      handleTabActivation(tabElement, tabSliderElement, Collapse);
      addClassToElements('clicked', [tabSliderElement])
      clearInterval(interval);
    })

    new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) return;
        if (entry.target.classList.contains('clicked')) {
          removeClassFromElements('clicked', [entry.target])
          interval = autoplayInterval(tabSliderElement, Collapse);
        }
      })
    }).observe(tabElement);
  });
}
